import Styles from "./Styles";

export default Styles.ButtonsContainer;
